export default __webpack_public_path__ + "static/media/QUICKSWAP_LOGO.e48ec73e.png";